module.exports = __webpack_public_path__ + "img/vub.686bbfeb.png";